import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { AssessmentAgencyService } from 'projects/services/src/app/API/assessment-agency.service';

declare var toastr: any;

@Component({
	selector: 'app-profile-view-assessment-agency',
	templateUrl: './profile-view-assessment-agency.component.html',
	styleUrls: ['./profile-view-assessment-agency.component.css']
})
export class ProfileViewAssessmentAgencyComponent implements OnInit {
	assessmentAgencyData: any;
	financialTurnOver: any=[];
	sscData: any;
	associateAa: any = [];
	assessmetModeList: any;
	languageList: any;
	panDocument: any;
	gstDocument: any;
	userName: any;
	gstNumber: any;
	panNumber: any;
	// prod issues temp sol
	mobile: any;
	website: any;
	// prod issues temp sol
	assessmentAgencyDataForm: FormGroup;
	constructor(
		private location: Location,
		private _assessmentAgencyService: AssessmentAgencyService,
		private _activatedRoute: ActivatedRoute,
		private _formBuilder: FormBuilder,
		private fileService: FileService,
	) {
		this.assessmentAgencyDataForm = _formBuilder.group({
			name: [''],
			userName: [''],
			type: [''],
			overAllExperience: [''],
			AssessmentAgencyAffiliation: [''],
			modeOfAssessment: this.assessmentAgencyDataForm && this.assessmentAgencyDataForm.value.modeOfAssessment ? [''] : 'N/A',
			affiliatedWithOtheSSC: this.assessmentAgencyDataForm && this.assessmentAgencyDataForm.value.affiliatedWithOtheSSC ? [''] : 'N/A',

			languagesForAssessment: [''],
			isoCertificationDetail: _formBuilder.group({
				isoCertified: [''],
				supportingDocument: ['']
			}),
			spoc: _formBuilder.group({
				firstName: [''],
				lastName: [''],
				email: [''],
				mobileNumber: ['']
			}),
			address: _formBuilder.group({
				address1: [''],

				landmark: [''],
				pinCode: [''],
				state: _formBuilder.group({
					code: [''],
					name: ['']
				}),
				district: _formBuilder.group({
					code: [''],
					name: ['']
				}),
				mandal: _formBuilder.group({

					code: [''],
					name: ['']
				}),
				city: _formBuilder.group({
					code: [''],
					name: ['']
				}),
				parliamentConstituency: _formBuilder.group({
					code: [''],
					name: ['']
				}),
				yearOfEstablishmentDetails: _formBuilder.group({
					year: ['']
				}),
				proof: [''],

			}),
			otherInformation: _formBuilder.group({
				candidatesAssessedTillDate: [''],
				numberOfAdminStaff: [''],
				workingUnderOtherProject: [''],
				keyAchievements: ['']
			}),

			// financialYearwiseTurnOverDetail: _formBuilder.group({
			// 	financialTurnOver: ['']
			// })

		})
		console.log(this.assessmentAgencyDataForm)
		_activatedRoute.params.subscribe(res => {
			console.log(res, _activatedRoute);
			const id = res.aaID ? res.aaID : res.id
			this.userName = id;
			this.getAssessmentAgencyData(id);

		})


	}

	ngOnInit() {
		const id = this._activatedRoute.snapshot.params.aaID || this._activatedRoute.snapshot.params.id
		this._assessmentAgencyService.getAssociateAA(id).subscribe(res => {
			console.log(res)
			if (res.data === null) {
				this.associateAa = []
			} else {
				this.associateAa = res.data;
			}
			console.log(this.associateAa);

		})
	}

	goBack() {
		this.location.back()
	}

	getAssessmentAgencyData(id) {

		this._assessmentAgencyService.getAssesmentAgencyByUserName(id).subscribe(res => {
			console.log(res)
			this.assessmentAgencyData = res
			this.assessmentAgencyDataForm.patchValue(res);
			this.assessmentAgencyDataForm.get('address').get('yearOfEstablishmentDetails').get('year').setValue(res.yearOfEstablishmentDetails.year ? res.yearOfEstablishmentDetails.year : '0000');
			if (res.isoCertificationDetail && res.isoCertificationDetail.isoCertified) {
				this.assessmentAgencyDataForm.get('isoCertificationDetail').get('isoCertified').setValue('YES');
			} else {
				this.assessmentAgencyDataForm.get('isoCertificationDetail').get('isoCertified').setValue('NO');
			}
			if(res.financialYearwiseTurnOverDetail){
				this.financialTurnOver=res.financialYearwiseTurnOverDetail
			}
			else{
				this.financialTurnOver=[]
			}
			console.log(this.assessmentAgencyDataForm);
			console.log(this.assessmentAgencyData.gstNumber);
			if (res.gstDetail && res.gstDetail.number) {
				this.gstNumber=res.gstDetail.number
			}
			else {
				this.gstNumber='N/A'
			}
			if (res.panDetail && res.panDetail.number) {
				this.panNumber=res.panDetail.number
			}
			else {
				this.panNumber='N/A'
			}
			this.panDocument = res.panDetail && res.panDetail.supportingDocument,
			this.gstDocument = res.gstDetail && res.gstDetail.supportingDocument


		})
	}

	opeFile(certificate) {
		if (certificate) {
			this.fileService.downloadAttachedFile(certificate);
		} else {
			toastr.error('Document Not Found');
		}

	}

	previewIsoDoc() {
		if (this.assessmentAgencyData.isoCertificationDetail.supportingDocument) {
			console.log(this.assessmentAgencyData.isoCertificationDetail.supportingDocument)
			this.fileService.downloadAttachedFile(this.assessmentAgencyData.isoCertificationDetail.supportingDocument);
		} else {
			toastr.error('No ISO Document Found');
		}
	}


	viewAddressProof(){
		if (this.assessmentAgencyData.address.proof.supportingDocument) {
			console.log(this.assessmentAgencyData.address.proof.supportingDocument)
			this.fileService.downloadAttachedFile(this.assessmentAgencyData.address.proof.supportingDocument);
		} else {
			toastr.error('No Address Proof Document Found');
		}

	}



}
